<template>
    <v-dialog v-bind="$attrs" persistent content-class="modal-dialog">
        <div class="modal-message">
            <div class="common-text mb-2">
                {{ editDevice.uid ? "Редактирование" : "Добавление" }} устройства
            </div>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                class="auth-form"
                @submit.prevent
            >
                <div class="main-text mb-5 text-center auth-form__container">
                    <div class="auth-form__input">
                        <label for="deviceName" class="main-text"> Название </label>
                        <v-text-field
                            v-model="dataDevice.name"
                            id="deviceNameAddDevice"
                            :rules="[rules.required]"
                            placeholder="Введите название"
                            class="dark-input ma-0"
                            dense
                        />
                    </div>
                    <div class="auth-form__input">
                        <label for="controllerAddDevice" class="main-text"> Контроллер </label>
                        <v-select
                            v-model="controller"
                            placeholder="Контроллер"
                            id="controllerAddDevice"
                            class="dark-input-select"
                            append-icon="mdi-chevron-down"
                            :items="controllers"
                            item-text="name"
                            item-value="uid"
                            :rules="[rules.required]"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                                width: '100%',
                            }"
                            @change="checkDisabled"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </div>
                    <div class="auth-form__input">
                        <label for="deviceTypeAddDevice" class="main-text"> Тип устройства </label>
                        <v-select
                            v-model="deviceType"
                            placeholder="Выберите тип устройства"
                            id="deviceTypeAddDevice"
                            class="dark-input-select"
                            append-icon="mdi-chevron-down"
                            :items="deviceTypes"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            :rules="[rules.required]"
                            return-object
                            @change="checkDisabled"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </div>
                    <div class="auth-form__input">
                        <label for="locationAddDevice" class="main-text"> Расположение </label>
                        <v-combobox
                            v-model="dataDevice.location"
                            placeholder="Расположение"
                            id="locationAddDevice"
                            class="dark-input-select"
                            :items="locations"
                            :rules="[rules.required]"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            hide-details
                            @update:search-input="setLocation"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item}}</v-flex>
                            </template>
                        </v-combobox>
                    </div>
                    <div class="auth-form__input">
                        <div class="d-inline-flex btn-block justify-start" style="width: 100%; max-width: 100%;">
                            <v-switch
                                v-model="!dataDevice.hidden"
                                inset
                                dense
                                class="pa-0 ma-0"
                                color="#FF8484"
                            />
                            <div class="main-text ml-2">Доступно гостю</div>
                        </div>
                    </div>
                </div>
                <v-flex class="d-flex w-100 justify-center mt-3">
                    <v-btn class="btn-dark main-text" @click="close">
                        Отменить
                    </v-btn>
                    <v-btn
                        :disabled="!valid"
                        type="submit"
                        class="yellow-btn small-btn main-text"
                        @click="validate"
                    >
                        Сохранить
                    </v-btn>
                </v-flex>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
import deviceTypesCode from "@/plugins/deviceTypesCode";

export default {
    name: "ModalAddDevice",
    props: {
        home: {
            type: String,
        },
        editDevice: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            dataDevice: {hidden: true},
            valid: true,
            rules: {
                required: value => !!value || 'Обязательное поле',
            },
            controller: null,
            controllers: [],
            locations: [],
            deviceType: null,
            deviceTypes: deviceTypesCode,
            disabled: false,
        };
    },
    created() {
        this.getControllers();
        this.getLocations();
        if (this.editDevice.uid) {
            this.dataDevice = JSON.parse(JSON.stringify(this.editDevice));
            this.controller = this.dataDevice.controller;
            this.deviceType = this.dataDevice.device_type;
        }
    },
    methods: {
        getControllers() {
            this.$http.get('/controllers/home/management-controller/' + this.home + '/')
                .then((response) => {
                    this.controllers = response.data.results;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getLocations() {
            this.locations = [];
            this.$http.get('/devices/home/devices-list/' + this.home + '/')
                .then((response) => {
                    this.locations = response.data.locations;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setLocation(val) {
            this.dataDevice.location = val;
            this.checkDisabled();
        },
        checkDisabled() {
            this.disabled = this.dataDevice.name && this.dataDevice.location && this.dataDevice.device_type;
        },
        close() {
            this.$emit('input', false);
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.valid) {
                this.saveDevice();
            }
        },
        saveDevice() {
            let save_data = {
                ...this.dataDevice,
                controller: this.controller,
                device_type: this.deviceType.code,
            };
            // let url = '/devices/home/devices/';
            // let method = "post";
            // if (this.editDevice.uid) {
            //     url = '/devices/home/devices/' + this.editDevice.uid + '/';
            //     method = "patch";
            // }
            // this.$http[method](url, save_data)
            //     .then(() => {
            //         this.$emit('update');
            //         this.close();
            //     });
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-message {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.btn-dark.v-btn {
    max-width: 107px;
}

.yellow-btn.small-btn.v-btn {
    width: auto;
    min-width: 105px;
    max-height: 42px;
    min-height: 42px;
    margin-left: 8px;
}
</style>